import { render } from "./ControlUnit.vue?vue&type=template&id=5c163c46"
import script from "./ControlUnit.vue?vue&type=script&lang=js"
export * from "./ControlUnit.vue?vue&type=script&lang=js"

import "./ControlUnit.vue?vue&type=style&index=0&id=5c163c46&lang=scss"

import exportComponent from "/app/widget-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__